import { config } from "core/utils";
import { isProgramSearchResultItem } from "./isProgramSearchResultItem";
export function getVariantForSearchResult(item) {
    if (isProgramSearchResultItem(item)) {
        return item.vtmgoRedirectEnabled
            ? config.tracking.vtmGo.program
            : undefined;
    }
    return undefined;
}
